import React, { useState } from "react";
import CourseReview from "./CourseReview";
import LearningCheckup from "./LearningCheckup";
import "./learningCheckup.css";

export default function ReviewWorkspace({ onOpenLesson }) {
  const [section, setSection] = useState("modules");
  return <section aria-label="Learning review workspace"><nav className="finance-review-views" aria-label="Review formats"><button type="button" aria-pressed={section === "modules"} onClick={() => setSection("modules")}>Modules<small>單元複習</small></button><button type="button" aria-pressed={section === "checkup"} onClick={() => setSection("checkup")}>Checkup<small>綜合情境</small></button></nav><div hidden={section !== "modules"}><CourseReview onOpenLesson={onOpenLesson} /></div><div hidden={section !== "checkup"}><LearningCheckup onOpenLesson={onOpenLesson} /></div></section>;
}
